var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"session"}},[_c('v-img',{staticClass:"mx-auto my-0",attrs:{"src":_vm.getLogo,"alt":_vm.getAlt,"max-width":"450px"}}),_vm._v(" "),(_vm.isBO)?_c('h1',[_vm._v("Backoffice")]):_vm._e(),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79d1eea6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Session.vue
// module id = null
// module chunks = 